import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["entries", "pagination"]

    scroll() {
        console.log(window.pageYOffset)
    }
}